var CurrentUser = require("lib/account/CurrentUser");

import moment from "moment";

function lastSpan(count, momentName, labelName) {
	var start = moment().subtract(count, momentName).format(FORMAT);
	
	var end = moment().format(FORMAT);
	var label = "Last " + count + " " + labelName;

	return { value: { "start": start, "end": end }, label: label };
}

function getDateSpanLabel(span, i) {
	var startd = new Date(span.start)
	var endd = new Date(span.end)
	var diff = parseInt((endd - startd) / (1000 * 60 * 60 * 24), 10);

	var period = "Week"
	if (diff > 200) {
		period = "School Year"
	} else if (diff > 170) {
		period = "Semester"
	} else if (diff > 80) {
		period = "Trimester"
	} else if (diff > 20) {
		period = "Month"
	}

	if (i == 1) {
		return `Last ${period}`
	} else if (i > 1) {
		return `${i} ${period}s Ago`
	} else {
		return `This ${period}`
	}
}

function getExpectationSpans(expectationSpans, expectation_count) {
	if (expectationSpans) {
		var dateSpans = expectationSpans;
		var defaultDateSpans = dateSpans.slice(0, expectation_count);

		return _.map(defaultDateSpans, function(span, s) {
			if (span.label) {
				return { value: _.pick(span, "start", "end"), label: span.label }
			} else {
				return { value: _.pick(span, "start", "end"), label: getDateSpanLabel(span, s) }
			}
		});
	} else {
		return [];
	}
}

function getSchoolYearSpan() {
	var schoolYearStart = moment(CurrentUser.fetchSchoolYearDates().startDate);

	var start = schoolYearStart.format(FORMAT);
	var end = moment().format(FORMAT);

	return { value: { "start": start, "end": end }, label: "This School Year" };
}

function renderSpan(option) {
	var startDate = moment(option.value.start).format("M/DD/YY");

	if (moment(option.value.end).startOf("day") >= moment().startOf("day")) {
		var endDate = "Today"
	} else {
		var endDate = moment(option.value.end).format("M/DD/YY");
	}

	return (
		<span>
			<span className="spanLabel">{ option.label }</span>{" "}
			<span className="spanDates">{ startDate } - { endDate }</span>
		</span>
	);
}

function widgetSpans(expectationSpans) {
	var dateOptions = [];

	// return all date spans since begining of school year
	dateOptions = dateOptions.concat(getExpectationSpans(expectationSpans, _.size(expectationSpans)));
	// var hasSchoolYear = _.findWhere(dateOptions, { label: SCHOOL_YEAR_LABEL });
	// if (hasSchoolYear == undefined) {
	// 	dateOptions.push(getSchoolYearSpan());
	// }

	return dateOptions;
}

function dashboardSpans(expectationSpans) {
	var dateOptions = [];

	dateOptions = dateOptions.concat(getExpectationSpans(expectationSpans, INITIAL_EXPECTATION_SPAN_COUNT));

	dateOptions.push(lastSpan(7, "days", "Days")); // Means there's always a "Last 7 Days" span
	dateOptions.push(lastSpan(30, "days", "Days")); // Means there's always a "Last 30 Days" span

	var hasSchoolYear = _.findWhere(dateOptions, { label: SCHOOL_YEAR_LABEL });
	if (hasSchoolYear == undefined) {
		dateOptions.push(getSchoolYearSpan());
	}

	if (expectationSpans && (expectationSpans.length > INITIAL_EXPECTATION_SPAN_COUNT)) {
		dateOptions.push({ value: OTHER_PERIODS, label: OTHER_PERIODS });
	}
	dateOptions.push({ value: CUSTOM_DATES, label: CUSTOM_DATES });

	return dateOptions;
}

function otherExpectationsSpans(expectationSpans) {
	if (expectationSpans) {
		var allDateSpans = expectationSpans;
		var otherPeriodSpans = allDateSpans.slice(INITIAL_EXPECTATION_SPAN_COUNT, allDateSpans.length);
		var otherPeriods = _.map(otherPeriodSpans, function(span) {
			return { value: _.pick(span, "start", "end"), label: span.label }
		});

		return otherPeriods;
	} else {
		return [];
	}
}

var OTHER_PERIODS = "Other Time Periods";
var CUSTOM_DATES = "Custom Dates";

var INITIAL_EXPECTATION_SPAN_COUNT = 2;

var FORMAT = "YYYY-MM-DD";
var SCHOOL_YEAR_LABEL = "This School Year";

module.exports = {
	OTHER_PERIODS, CUSTOM_DATES, FORMAT,
	renderSpan,
	dashboardSpans, otherExpectationsSpans, widgetSpans
}




// WEBPACK FOOTER //
// ./modules/lib/data/DateSpans.js